import {
	ChangeDetectionStrategy,
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';
import {
	NavigationEnd,
	NavigationStart,
	Router,
	RouterModule,
} from '@angular/router';
import { Subscription } from 'rxjs';

import { NotificationService } from '@core/services/notification.service';
import { UserService } from '@core/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { PaymentNotificationDialogComponent } from '@shared/components/payment-notification-dialog/payment-notification-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { FooterComponent } from '../footer/footer.component';
import { CommunityHeaderComponent } from '../community-header/community-header.component';

@Component({
	selector: 'kwo-main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: ['./main-layout.component.scss'],
	standalone: true,
	imports: [RouterModule, FooterComponent, CommunityHeaderComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent implements OnInit, OnDestroy {
	private routeSubscription: Subscription;

	constructor(
		router: Router,
		userService: UserService,
		private notificationService: NotificationService,
		public dialog: MatDialog,
	) {
		const user = userService.getUser();

		this.routeSubscription = router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {
				notificationService.hideNotifications();
			}

			if (event instanceof NavigationEnd) {
				const showPaymentNotification =
					sessionStorage.getItem('kwo-payment') ?? 'true';
				if (
					user &&
					user.has_open_payments &&
					showPaymentNotification === 'true'
				) {
					this.dialog.open(PaymentNotificationDialogComponent, {
						width: '600px',
						scrollStrategy: new NoopScrollStrategy(),
						data: { payment_uri: user.payment_uri },
					});
				}

				if (!user) {
					this.notificationService.showBecomeMemberNotification();
				}
			}
		});
	}

	ngOnInit() {}

	ngOnDestroy(): void {
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}
}
